import { type TicketActionTypeEnum } from '@/common/types/case'

export const enum CaseActionModalEnum {
  DELETE = 'DELETE',
  COMPLETE = 'COMPLETE',
  COMPLETEONVALIDATION = 'COMPLETEONVALIDATION',
  PUTBACKINPOOL = 'PUTBACKINPOOL',
  REOPEN = 'REOPEN',
  TRANSFER = 'TRANSFER',
  ASSIGN = 'ASSIGN',
  HANDLE_INTERACTIONS = 'HANDLE_INTERACTIONS',
  REASSIGN = 'REASSIGN',
  ESCALATE = 'ESCALATE',
  CATEGORIZE = 'CATEGORIZE',
  ATTACHPARENT = 'ATTACHPARENT',
  ASKFORVALIDATION = 'ASKFORVALIDATION',
  UNDOVALIDATION = 'UNDOVALIDATION',
  APPROVE = 'APPROVE',
  DISAPPROVE = 'DISAPPROVE',
  STACK = 'STACK',
  STACKANDPUTBACKINPOOL = 'STACKANDPUTBACKINPOOL',
  STACKANDREASSIGN = 'STACKANDREASSIGN',
  STACKANDTRANSFER = 'STACKANDTRANSFER',
  UPDATEDUEDATE = 'UPDATEDUEDATE',
  TAKEON = 'TAKEON',
}

export enum CaseReadinessActionsEnum {
  ASKFORVALIDATION = 'ASKFORVALIDATION',
  COMPLETE = 'COMPLETE',
  COMPLETEONVALIDATION = 'COMPLETEONVALIDATION',
  DELETE = 'DELETE',
  STACK = 'STACK',
  TRANSFER = 'TRANSFER',
  UPDATEDUEDATE = 'UPDATEDUEDATE',
}

export type CaseActionModalType = keyof typeof CaseActionModalEnum

export interface BaseCaseActionDTOV1 {
  comment?: string
  reasonCode?: string
}

export interface CompleteActionDTOV1 extends BaseCaseActionDTOV1 {
  autoCloseInteractions?: boolean
}

export type AskForValidationActionDTOV1 = BaseCaseActionDTOV1

export type ReopenActionDTOV1 = BaseCaseActionDTOV1

export type CancelCaseActionDTOV1 = BaseCaseActionDTOV1

export type UndoValidationCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type ApproveCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type DisapproveCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type ReleaseCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type AssignCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'> & {
  userLogin?: string
}

export type ReassignCaseActionDTOV1 = AssignCaseActionDTOV1

export interface TransferCaseActionDTOV1 extends BaseCaseActionDTOV1 {
  skillCode?: string
}

export interface StackCaseActionDTOV1 extends BaseCaseActionDTOV1 {
  wakeupDate?: string
}

export type StackAndReleaseCaseActionDTOV1 = StackCaseActionDTOV1

export interface StackAndReassignCaseActionDTOV1 extends StackCaseActionDTOV1 {
  userLogin?: string
}

export type StackAndTransferCaseActionDTOV1 = Omit<StackAndReassignCaseActionDTOV1, 'reasonCode'> & {
  transferReasonCode?: string
  putOnHoldReasonCode?: string
  skillCode?: string
}

export interface UpdateDateDueCaseActionDTOV1 extends BaseCaseActionDTOV1 {
  dueDate?: string
}
export type PerformCaseActionPayloadDTOV1 =
  | CompleteActionDTOV1
  | AskForValidationActionDTOV1
  | ReopenActionDTOV1
  | CancelCaseActionDTOV1
  | UndoValidationCaseActionDTOV1
  | ApproveCaseActionDTOV1
  | DisapproveCaseActionDTOV1
  | ReleaseCaseActionDTOV1
  | AssignCaseActionDTOV1
  | ReassignCaseActionDTOV1
  | TransferCaseActionDTOV1
  | StackCaseActionDTOV1
  | StackAndReleaseCaseActionDTOV1
  | StackAndReassignCaseActionDTOV1
  | StackAndTransferCaseActionDTOV1
  | UpdateDateDueCaseActionDTOV1

export interface ListCaseActionsParams {
  'include-empty-comment'?: boolean
  type?: TicketActionTypeEnum[]
  user?: string[]
  page?: number
  size?: number
  'sort-field'?: CaseActionsSortFieldEnum
  'sort-direction'?: CaseActionsSortDirectionEnum
  include?: CaseActionsIncludeEnum[]
}

export type CaseActionAuditValue = string | number | string[] | number[] | { data: string | number }[]

export interface CaseActionAuditDTOV1 {
  field: string
  type: string
  oldValue?: CaseActionAuditValue
  newValue?: CaseActionAuditValue
}

export interface BasicCaseActionDTOV1 {
  date: string
  type: TicketActionTypeEnum
  comment?: string
  user?: string
  reasonCode?: string
}

export type CaseActionDTOV1 = BasicCaseActionDTOV1 & {
  id: number
  caseId: number
  afterActionAssigneeLogin?: string
  childToRedirectTo?: number
}

export type ListCaseActionDTOV1 = BasicCaseActionDTOV1 & {
  afterActionSkillCode: string
  afterActionStatus: string
  beforeActionAssigneeLogin?: string
  afterActionAssigneeLogin?: string
  beforeActionSkillCode?: string
  beforeActionStatus?: string
  audit?: CaseActionAuditDTOV1[]
  wakeupDate?: string
  fileImportId?: number
}

export type CaseActionResponse = CaseActionDTOV1 | CaseActionDTOV1[]

interface CaseActionsMetadataSubDTOV1<TUsers = string> {
  number: number
  users: Array<TUsers>
  actionTypes: TicketActionTypeEnum[]
}

export interface CaseActionsMetadataDTOV1 {
  withOrWithoutComment?: CaseActionsMetadataSubDTOV1<string | null>
  withComment?: CaseActionsMetadataSubDTOV1
}

export enum CaseActionsSortFieldEnum {
  DATE = 'DATE',
}

export enum CaseActionsSortDirectionEnum {
  DESCENDING = 'DESCENDING',
  ASCENDING = 'ASCENDING',
}

export enum CaseActionsIncludeEnum {
  FIELDS_AUDIT = 'FIELDS_AUDIT',
}
